import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SvgIconComponent } from '@ngneat/svg-icon';
import { TranslatePipe } from '@ngx-translate/core';
import { PerioCheatSheetRowComponent } from '../perio-cheat-sheet-row/perio-cheat-sheet-row.component';

@Component({
  selector: 'lib-perio-cheat-sheet',
  imports: [CommonModule, PerioCheatSheetRowComponent, SvgIconComponent, TranslatePipe],
  templateUrl: './perio-cheat-sheet.component.html',
  styleUrl: './perio-cheat-sheet.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PerioCheatSheetComponent {
  public readonly isTopConfigDisabled = input.required<boolean>();
  public readonly isBottomConfigDisabled = input.required<boolean>();
}
